import React, { useState, useEffect, useCallback } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import logoWelding from "../../imagens/logos/logoWelding.png"
import "./weldingCapabilities.css"

function WeldingsCapabilities({ listWelding }) {
  const [slideNumber, setSlideNumber] = useState(0)
  const [openModal, setOpenModal] = useState(false)

  const handleOpenModal = (index) => {
    setSlideNumber(index)
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const prevSlide = useCallback(() => {
    slideNumber === 0 ?
      setSlideNumber(listWelding.length - 1) :
      setSlideNumber(slideNumber - 1)
  }, [slideNumber, listWelding.length])


  const nextSlide = useCallback(() => {
    slideNumber + 1 === listWelding.length
      ? setSlideNumber(0) :
      setSlideNumber(slideNumber + 1)
  }, [slideNumber, listWelding.length])

  useEffect(() => {
    const handleKeyDown = (event) => {
      switch (event.key) {
        case 'Escape':
          handleCloseModal()
          break
        case 'ArrowLeft':
          prevSlide()
          break;
        case 'ArrowRight':
          nextSlide()
          break;
        default:
          break;
      }
    };

    if (openModal) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [openModal, nextSlide, prevSlide]);

  return (
    <div>
      {
        openModal &&
        <div className='weldSliderWrap'>
          <FontAwesomeIcon icon={faCircleChevronLeft} className='weldBtnPrev' onClick={() => prevSlide()} />
          <FontAwesomeIcon icon={faCircleChevronRight} className='weldBtnNext' onClick={() => nextSlide()} />
          <FontAwesomeIcon icon={faCircleXmark} className='weldBtnClose' onClick={() => handleCloseModal()} />
          <img className='weldFullScreenImage' src={listWelding[slideNumber].img} alt="FullScreenImage" />
        </div>
      }
      <div className='img-custom-size img-fluid ms-2'>
        <img src={logoWelding} alt='logoWelding' />
      </div>
      <div className='weldGalleryWrap mx-2'>
        {
          listWelding && listWelding.map((image, index) => {
            return (
              <div className='weldSingle'
                key={index}
                onClick={() => handleOpenModal(index)}
              >
                <img src={image.img} alt="welding"></img>

              </div>
            )

          })
        }
      </div>
      <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/Production">
                    <button className="buttonCapabilities">Back to Production Capabilities</button>
                </Link>
            </div>

    </div>
  )

}

export default WeldingsCapabilities 